(function($) {
  $(function(){
  
    /*****
      Fancybox
      ---
      This is just sample code, to be extended
    *****/
    $().fancybox({
      selector : '.video-lightbox, .photo-lightbox',
      hash: false,
      buttons: ['close'],
      infobar: false,
      idleTime: 300
    });
  
  });
  })(jQuery);
